module.exports = __webpack_public_path__ + "static/media/icon-clients-white.0c26340f.svg";